export const SEON_SESSION_ID_HEADER = "seon-session-id";

export enum SEON_FEATURE {
  ONBOARDING = "onboarding",
  LOGIN = "login",
  REGISTER = "register",
  DEPOSIT = "deposit",
  WITHDRAWAL = "withdrawal",
  PROMOTION = "promotion",
  PROMOTION_CASHBACK = "promotion_cashback",
  PROMOTION_MEGA_SHARE = "promotion_mega_share",
  PROMOTION_DAILY_LOGIN = "promotion_daily_login",
  PROMOTION_CASHBACK_DAILY = "promotion_cashback_daily",
  PROMOTION_CASHBACK_WEEKLY = "promotion_cashback_weekly",
  PROMOTION_CASHBACK_MONTHLY = "promotion_cashback_monthly",
  PROMOTION_CASHBACK_INSTANT = "promotion_cashback_instant",
  PROMOTION_REFER_FRIEND = "promotion_refer_friend",
  PROMOTION_REFER_BALLS = "promotion_refer_balls",
  PROMOTION_SECRET_CODE = "promotion_secret_code",
}

/**
 * List of critical SEON features that require high accuracy.
 * These features should NOT use performanceMode to maintain accuracy.
 * Only financial transactions (deposit, withdrawal) are considered critical.
 */
export const SEON_CRITICAL_FEATURES: SEON_FEATURE[] = [];

/**
 * List of SEON features that are disabled.
 * Remove features from this array to re-enable SEON for them.
 */
export const SEON_DISABLED_FEATURES: SEON_FEATURE[] = [
  SEON_FEATURE.PROMOTION,
  SEON_FEATURE.PROMOTION_CASHBACK,
  SEON_FEATURE.PROMOTION_MEGA_SHARE,
  SEON_FEATURE.PROMOTION_DAILY_LOGIN,
  SEON_FEATURE.PROMOTION_CASHBACK_DAILY,
  SEON_FEATURE.PROMOTION_CASHBACK_WEEKLY,
  SEON_FEATURE.PROMOTION_CASHBACK_MONTHLY,
  SEON_FEATURE.PROMOTION_CASHBACK_INSTANT,
  SEON_FEATURE.PROMOTION_REFER_FRIEND,
  SEON_FEATURE.PROMOTION_REFER_BALLS,
  SEON_FEATURE.PROMOTION_SECRET_CODE,
];
